import { mapState } from "vuex";

export default {
  name: "the-sidebar",
  data() {
    return {
      display: {
        menu: "dashboard",
      },
      menu_list: [],
      menus: [
        {
          name: "Dashboard",
          title: "DASHBOARD",
          routeName: "dashboard",
          icon: "fas fa-tachometer-alt",
          path: ["/"],
        },
        {
          name: "Customer",
          title: "CUSTOMER",
          routeName: "ListCustomer",
          icon: "fas fa-angle-double-right",
          path: ["/customer", "/customer/customer"],
        },
        {
          name: "Customer Group",
          title: "CUSTOMER_GROUP",
          routeName: "ListCustomerGroup",
          icon: "fas fa-angle-double-right",
          path: ["/customer", "/customer/customer-group"],
        },
        {
          name: "Brand",
          title: "BRAND",
          routeName: "ListBrand",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/brand"],
        },
        {
          name: "Category",
          title: "CATEGORY",
          routeName: "ListCategory",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/category"],
        },
        {
          name: "Coupon",
          title: "COUPON",
          routeName: "ListCoupon",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/coupon"],
        },
        {
          name: "Options",
          title: "OPTION",
          routeName: "ListOption",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/option"],
        },
        {
          name: "Product",
          title: "PRODUCT",
          routeName: "ListProduct",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/product"],
        },
        {
          name: "Product Discount",
          title: "PRODUCT_DISCOUNT",
          routeName: "ListProductDiscount",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/product-discount"],
        },
        {
          name: "Special Blend",
          title: "CUSTOMER_SPECIAL_BLEND",
          routeName: "ListSpecialBlend",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/special-blend"],
        },
        {
          name: "Top Selection",
          title: "TOP_SELECTION",
          routeName: "ListTopSelection",
          icon: "fas fa-angle-double-right",
          path: ["/catalog", "/catalog/top-selection"],
        },
        {
          name: "Normal Order",
          title: "ORDER",
          routeName: "ListOrder",
          icon: "fas fa-angle-double-right",
          path: ["/order", "/order/normal-order"],
        },
        {
          name: "Special Blend",
          title: "ORDER",
          routeName: "ListSpecialBlendOrder",
          icon: "fas fa-angle-double-right",
          path: ["/order", "/order/special-blend-order"],
        },
        {
          name: "Quotation",
          title: "QUOTATION",
          routeName: "ListQuotation",
          icon: "fas fa-angle-double-right",
          path: ["/order", "/order/order-quotation"],
        },
        {
          name: "Order Status",
          title: "ORDER_STATUS",
          routeName: "ListOrderStatus",
          icon: "fas fa-angle-double-right",
          path: ["/order", "/order/order-status"],
        },
        {
          name: "Merchanside",
          title: "MERCHANDISE",
          path: [
            "/point-and-merchandise",
            "/point-and-merchandise/merchandise",
          ],
        },
        {
          name: "Advertisement",
          title: "ADVERTISEMENT",
          routeName: "ListAdvertisement",
          icon: "fas fa-angle-double-right",
          path: ["/campaign", "/campaign/advertisement"],
        },
        {
          name: "Promotion",
          title: "PROMOTION",
          routeName: "ListPromotion",
          icon: "fas fa-angle-double-right",
          path: ["/campaign", "/campaign/promotion"],
        },
        {
          name: "Notification",
          routeName: "ListNotification",
          title: "NOTIFICATION",
          icon: "fas fa-angle-double-right",
          path: ["/campaign", "/campaign/notification"],
        },
        {
          name: "Popup Banner",
          routeName: "ListPopupBanner",
          title: "ADS_POPUP",
          icon: "fas fa-angle-double-right",
          path: ["/campaign", "/campaign/popup-banner"],
        },
        {
          name: "Geo Zone",
          title: "GEO_ZONE",
          routeName: "ListGeoZone",
          icon: "fas fa-angle-double-right",
          path: ["/address", "/address/geo-zone"],
        },
        {
          name: "Zone to Geo Zone",
          title: "ZONE_TO_GEO_ZONE",
          routeName: "ListZoneToGeoZone",
          icon: "fas fa-angle-double-right",
          path: ["/address", "/address/zone-to-geo-zone"],
        },
        {
          name: "Ticket Type",
          title: "TICKET_TYPE",
          routeName: "ListTicketType",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/ticket-type"],
        },
        {
          name: "Checkup Request",
          title: "CHECKUP_REQUEST",
          routeName: "ListCheckupRequest",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/checkup-request"],
        },
        {
          name: "Service Package",
          title: "SERVICE_PACKAGE_REQUEST",
          routeName: "ListServicePackage",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/service-package"],
        },
        {
          name: "Barista Request",
          title: "BARISTA_REQUEST",
          routeName: "ListBaristaRequest",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/barista-request"],
        },
        {
          name: "Training Course",
          title: "TRAINING_COURSE_REQUEST",
          routeName: "ListTrainingCourse",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/training-course"],
        },
        {
          name: "E-Warranty Card",
          title: "E_WARRANTY_CARD",
          routeName: "ListEWarrantyCard",
          icon: "fas fa-angle-double-right",
          path: ["/ticket", "/ticket/e-warranty-card"],
        },
        {
          name: "Tutorial Playlist",
          title: "TUTORIAL_PLAYLIST",
          routeName: "ListTutorialPlaylist",
          icon: "fas fa-angle-double-right",
          path: ["/tutorial", "/tutorial/tutorial-playlist"],
        },
        {
          name: "Tutorial Video",
          title: "TUTORIAL_VIDEO",
          routeName: "ListTutorialVideo",
          icon: "fas fa-angle-double-right",
          path: ["/tutorial", "/tutorial/tutorial-video"],
        },
        {
          name: "Delivery Condition",
          routeName: "ListDeliveryCondition",
          title: "DELIVERY_FEE",
          icon: "fas fa-angle-double-right",
          path: ["/delivery", "/delivery/delivery-condition"],
        },
        {
          name: "Delivery Branch",
          routeName: "ListDeliveryFeeBranch",
          title: "DELIVERY_FEE_BRANCH",
          icon: "fas fa-angle-double-right",
          path: ["/delivery", "/delivery/delivery-branch"],
        },
        {
          name: "Delivery District",
          routeName: "ListDeliveryFeeDistrict",
          title: "DELIVERY_FEE_DISTRICT",
          icon: "fas fa-angle-double-right",
          path: ["/delivery", "/delivery/delivery-district"],
        },
        {
          name: "Showroom",
          routeName: "ListShowroom",
          title: "SHOWROOM",
          icon: "fas fa-store-alt",
          path: ["/showroom", "/showroom/edit"],
        },
        {
          name: "Warehouse",
          routeName: "ListWarehouse",
          title: "WAREHOUSE",
          icon: "fas fa-angle-double-right",
          path: ["/warehouse", "/warehouse/warehouse"],
        },
        {
          name: "Branch",
          routeName: "ListBranch",
          title: "BRANCH",
          icon: "fas fa-angle-double-right",
          path: ["/warehouse", "/warehouse/branch"],
        },
        {
          name: "Product/Showroom",
          routeName: "ListProductReview",
          title: "REVIEW",
          icon: "fas fa-angle-double-right",
          path: ["/review", "/review/product-showroom"],
        },
        {
          name: "Customer Feedback",
          routeName: "ListCustomerFeedback",
          title: "FEEDBACK",
          icon: "fas fa-angle-double-right",
          path: ["/review", "/review/customer-feedback"],
        },
        {
          name: "Admin Accounts",
          title: "ADMIN_ACCOUNT",
          routeName: "ListAdminAccount",
          icon: "fas fa-angle-double-right",
          path: ["/setting", "/setting/admin-management"],
        },
        {
          name: "Payment Method",
          title: "PAYMENT_METHOD",
          routeName: "ListPaymentMethod",
          icon: "fas fa-angle-double-right",
          path: ["/payment", "/payment/payment-method"],
        },
        {
          name: "Role Management",
          title: "ADMIN_ROLE",
          routeName: "ListRole",
          icon: "fas fa-angle-double-right",
          path: ["/setting", "/setting/role-management"],
        },
        {
          name: "Language",
          routeName: "Language",
          title: "LANGUAGE",
          icon: "fa fa-language",
          path: ["/setting", "/setting/language"],
        },
        {
          name: "Report",
          routeName: "ListReportOrder",
          title: "REPORT",
          icon: "fas fa-file-contract",
          path: ["/report", "/report/order"],
        },
        {
          name: "System Setting",
          title: "SETTING",
          routeName: "ListSettings",
          icon: "fas fa-angle-double-right",
          path: ["/setting", "/setting/system-setting"],
        },
        {
          name: "Special Blend Setting",
          title: "SPECIAL_BLEND_SETTING",
          routeName: "ListSpecialBlendSetting",
          icon: "fas fa-angle-double-right",
          path: ["/setting", "/setting/special-blend-setting"],
        },
        {
          name: "App Version",
          title: "APP_VERSION",
          routeName: "ListAppVersion",
          icon: "fas fa-angle-double-right",
          path: ["/setting", "/setting/app-version"],
        },
      ],
    };
  },
  components: {},
  computed: mapState(["accountInfo"]),
  created() {
    // Only call getPermission if accountInfo exists and has role.permissionGroups
    if (this.$store.state.accountInfo?.role?.permissionGroups) {
      this.getPermission();
    }
  },
  watch: {
    "$store.state.accountInfo": {
      handler(newVal) {
        if (newVal?.role?.permissionGroups) {
          this.getPermission();
        }
      },
      deep: true,
      immediate: true, // Trigger immediately on component mount
    },
  },
  methods: {
    isActive(item) {
      try {
        if (this.$route.path === "/" && item.path[0] === "/") {
          return true;
        }
        if (this.$route.path === item.path[0]) {
          return true;
        }
        if (this.$route.path === item.path[1]) {
          return true;
        }

        let path = item?.path || "";
        if (path) {
          path = path.split("/");

          if (path && path.length > 1) {
            const newPath = `/${path[1]}`;
            const route = this.$route.path.split("/");

            if (route && route.length > 2) {
              if (path[1] === route[1]) {
                item.dropdown = true;
              }
            }

            return newPath === this.$route.path ? true : false;
          }
        }

        return false;
      } catch (error) {
        return false;
      }
    },

    isSubActive(item) {
      try {
        if (item.path && item.path.length > 1) {
          const route = (this.$route.path && this.$route.path.split("/")) || "";

          if (route && route.length > 3) {
            const newRoute = `/${route[1]}/${route[2]}`;

            return newRoute === item.path[1] ? true : false;
          } else {
            return this.$route.path === item.path[1] ? true : false;
          }
        }

        return false;
      } catch (error) {
        return false;
      }
    },

    autoExpandActiveDropdown(auto = true) {
      if (!this.menu_list || this.menu_list.length === 0) return;

      this.menu_list.forEach((item) => {
        if (item.children && this.isActive(item)) {
          this.$set(item, "dropdown", auto);
        }
      });
    },

    getPermission() {
      if (this.$store.state.accountInfo) {
        // Safely get permissions (fallback to empty array if undefined)
        const permissions =
          this.$store.state.accountInfo?.role?.permissionGroups || [];
        const menu = this.menus;

        let permission = [];

        // ========= FILTER EVERY PERMISSION THAT GET FROM API TO COMPARE WITH MENU STORED IN STATE ============
        let mainMenu = menu.filter(function (menu) {
          return permissions.some(function (el) {
            if (menu.title === el.groupName) {
              permission.push(el);
            }
            return menu.title === el.groupName;
          });
        });

        // ========= CHECK IF THE PERMISSION HAVE SUB MENU ============
        let customerChildren = [];
        let campaignChildren = [];
        let catalogChildren = [];
        let merchandiseChildren = [];
        let voucherChildren = [];
        let paymentChildren = [];
        let addressChildren = [];
        let ticketChildren = [];
        let tutorialChildren = [];
        let orderChildren = [];
        let settingChildren = [];
        let reportChildren = [];
        let reviewChildren = [];
        let warehouseChildren = [];
        let deliveryChildren = [];

        mainMenu.find((item, index) => {
          //check if mainMenu have sub menu of CUSTOMER AND CUSTOMER GROUP. Then store in it one array (customerChildren)
          if (item.title == "CUSTOMER" || item.title == "CUSTOMER_GROUP") {
            customerChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check if mainMenu have sub menu of campaign. Then store in it one array (campaignChildren)
          else if (
            item.title == "ADS_POPUP" ||
            item.title == "ADVERTISEMENT" ||
            item.title == "PROMOTION" ||
            item.title == "NOTIFICATION"
          ) {
            campaignChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group CATALOG then store in it one array (catalogChildren)
          else if (
            item.title == "BRAND" ||
            item.title == "CATEGORY" ||
            item.title == "COUPON" ||
            item.title == "MANUFACTURER" ||
            item.title == "OPTION" ||
            item.title == "PRODUCT" ||
            item.title == "CUSTOMER_SPECIAL_BLEND" ||
            item.title == "PRODUCT_DISCOUNT" ||
            item.title == "STOCK_STATUS" ||
            item.title == "TOP_SELECTION" ||
            item.title == "UNIT_OF_MEASURE"
          ) {
            catalogChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group ORDER then store in it one array (orderChildren)
          else if (
            item.title == "ORDER" ||
            item.title == "ORDER_STATUS" ||
            item.title == "QUOTATION"
          ) {
            orderChildren.push(item);
            mainMenu[index].hidden = true;
          }

          // //check sub menu of permission group Report then store in it one array (reportChildren)
          else if (item.title == "REPORT") {
            let children = [
              {
                name: "Customer Report",
                routeName: "ListReportCustomer",
                title: "FILTER_ORDER_REPORT",
                icon: "fas fa-angle-double-right",
                path: ["/report", "/report/customer"],
              },
              {
                name: "Order Report",
                routeName: "ListReportOrder",
                title: "FILTER_ORDER_REPORT",
                icon: "fas fa-angle-double-right",
                path: ["/report", "/report/order"],
              },
              {
                name: "Service Ticket Report",
                routeName: "ListReportServiceTicket",
                title: "FILTER_TICKET_REPORT",
                icon: "fas fa-angle-double-right",
                path: ["/report", "/report/service-ticket-report"],
              },
              {
                name: "Academy Ticket Report",
                routeName: "ListReportAcademyTicket",
                title: "FILTER_TICKET_REPORT",
                icon: "fas fa-angle-double-right",
                path: ["/report", "/report/academy-ticket-report"],
              },
              {
                name: "Training Ticket Report",
                routeName: "ListReportTrainingTicket",
                title: "FILTER_TICKET_REPORT",
                icon: "fas fa-angle-double-right",
                path: ["/report", "/report/training-ticket-report"],
              },
            ];
            reportChildren = children;
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group POINT AND MERCHANDISE then store in it one array (merchandiseChildren)
          else if (item.title == "MERCHANDISE") {
            // create new array as Point and Merchandise have seperate table in Admin Dashboard but stay under one permission group
            let children = [
              {
                name: "Merchandise",
                title: "MERCHANDISE",
                routeName: "ListMerchandise",
                icon: "fas fa-angle-double-right",
                path: [
                  "/point-and-merchandise",
                  "/point-and-merchandise/merchandise",
                ],
              },
              {
                name: "Point Exchange",
                title: "POINT_EXCHANGE",
                routeName: "ListPointExchange",
                icon: "fas fa-angle-double-right",
                path: [
                  "/point-and-merchandise",
                  "/point-and-merchandise/point-exchange",
                ],
              },
            ];

            merchandiseChildren = children;
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group VOUCHER then store in it one array (voucherChildren)
          else if (item.title == "VOUCHER" || item.title == "VOUCHER_THEME") {
            voucherChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group PAYMENT then store in it one array (paymentChildren)
          else if (item.title == "CURRENCY" || item.title == "PAYMENT_METHOD") {
            paymentChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group ADDRESS then store in it one array (addressChildren)
          else if (
            item.title == "GEO_ZONE" ||
            item.title == "ZONE_TO_GEO_ZONE"
          ) {
            addressChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group TICKET then store in it one array (ticketChildren)
          else if (
            item.title == "TICKET_TYPE" ||
            item.title == "CHECKUP_REQUEST" ||
            item.title == "BARISTA_REQUEST" ||
            item.title == "TRAINING_COURSE_REQUEST" ||
            item.title == "SERVICE_PACKAGE_REQUEST" ||
            item.title == "E_WARRANTY_CARD"
          ) {
            //create new sub menu
            ticketChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group TUTORIAL then store in it one array (tutorialChildren)
          else if (
            item.title == "TUTORIAL_PLAYLIST" ||
            item.title == "TUTORIAL_VIDEO"
          ) {
            tutorialChildren.push(item);
            mainMenu[index].hidden = true;
          }

          // check sub menu of permission group warehouse then store in it one array (warehouseChildren)
          else if (item.title == "WAREHOUSE" || item.title == "BRANCH") {
            warehouseChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group review then store in it one array (reviewChildren)
          else if (item.title == "REVIEW" || item.title == "FEEDBACK") {
            reviewChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group SETTING then store in it one array (settingChildren)
          else if (
            item.title == "ADMIN_ACCOUNT" ||
            item.title == "ADMIN_ROLE" ||
            item.title == "APP_VERSION" ||
            item.title == "PAYMENT_METHOD" ||
            item.title == "LANGUAGE" ||
            item.title == "SETTING" ||
            item.title == "SPECIAL_BLEND_SETTING"
          ) {
            settingChildren.push(item);
            mainMenu[index].hidden = true;
          }

          //check sub menu of permission group DELIVERY then store in it one array (deliveryChildren)
          else if (
            item.title == "DELIVERY_FEE" ||
            item.title == "DELIVERY_FEE_BRANCH" ||
            item.title == "DELIVERY_FEE_DISTRICT"
          ) {
            deliveryChildren.push(item);
            mainMenu[index].hidden = true;
          }
        });

        // ========= ADD SUB-MENU UNDER MAIN MENU ============
        // Customer
        if (customerChildren.length > 0) {
          let obj = {
            name: "Customer",
            routeName: "",
            title: "Customer",
            icon: "fas fa-user-friends",
            dropdown: false,
            children: customerChildren,
            path: "/customer",
          };
          // reorder the main menu
          mainMenu.splice(1, 0, obj);
        }

        // campaign
        if (campaignChildren.length > 0) {
          let obj = {
            name: "Campaign",
            routeName: "",
            title: "Campaign",
            icon: "fas fa-bullhorn",
            dropdown: false,
            children: campaignChildren,
            path: "/campaign",
          };
          mainMenu.splice(2, 0, obj);
        }

        // Catalog
        if (catalogChildren.length > 0) {
          let obj = {
            name: "Catalog",
            routeName: "",
            title: "Catalog",
            icon: "fas fa-tags",
            dropdown: false,
            children: catalogChildren,
            path: "/catalog",
          };
          mainMenu.splice(3, 0, obj);
        }

        // Order
        if (orderChildren.length > 0) {
          let obj = {
            name: "Order",
            routeName: "",
            title: "Order",
            icon: "fa fa-cart-plus",
            dropdown: false,
            children: orderChildren,
            path: "/order",
          };
          mainMenu.splice(4, 0, obj);
        }

        // Point and Merchandise
        if (merchandiseChildren.length > 0) {
          let obj = {
            name: "Point & Merchandise",
            routeName: "",
            title: "Point & Merchandise",
            icon: "fas fa-star",
            dropdown: false,
            children: merchandiseChildren,
            path: "/point-and-merchandise",
          };
          mainMenu.splice(5, 0, obj);
        }

        // Payment
        if (paymentChildren.length > 0) {
          let obj = {
            name: "Payment",
            routeName: "",
            title: "Payment",
            icon: "fas fa-money-check",
            dropdown: false,
            children: paymentChildren,
            path: "/payment",
          };
          mainMenu.splice(6, 0, obj);
        }

        // Voucher
        if (voucherChildren.length > 0) {
          let obj = {
            name: "Voucher",
            routeName: "",
            title: "Voucher",
            icon: "fas fa-percent",
            dropdown: false,
            children: voucherChildren,
            path: "/voucher",
          };
          mainMenu.splice(7, 0, obj);
        }

        // Ticket
        if (ticketChildren.length > 0) {
          let obj = {
            name: "Ticket",
            routeName: "",
            title: "Ticket",
            icon: "fas fa-ticket-alt",
            dropdown: false,
            children: ticketChildren,
            path: "/ticket",
          };
          mainMenu.splice(8, 0, obj);
        }

        // Tutorial
        if (tutorialChildren.length > 0) {
          let obj = {
            name: "Tutorial",
            routeName: "",
            title: "Tutorial",
            icon: "fa fa-video",
            dropdown: false,
            children: tutorialChildren,
            path: "/tutorial",
          };
          mainMenu.splice(9, 0, obj);
        }

        // Address
        if (addressChildren.length > 0) {
          let obj = {
            name: "Address",
            routeName: "",
            title: "Address",
            icon: "fa fa-map-marker",
            dropdown: false,
            children: addressChildren,
            path: "/address",
          };
          mainMenu.splice(10, 0, obj);
        }

        // Warehouse and Branch
        if (warehouseChildren.length > 0) {
          let obj = {
            name: "Warehouse",
            routeName: "",
            title: "Warehouse",
            icon: "fas fa-home",
            dropdown: false,
            children: warehouseChildren,
            path: "/warehouse",
          };
          mainMenu.splice(11, 0, obj);
        }

        // Review
        if (reviewChildren.length > 0) {
          let obj = {
            name: "Review",
            routeName: "",
            title: "Review",
            icon: "fa fa-comments",
            dropdown: false,
            children: reviewChildren,
            path: "/review",
          };
          mainMenu.splice(12, 0, obj);
        }

        // Report
        if (reportChildren.length > 0) {
          let obj = {
            name: "Report",
            routeName: "",
            title: "Report",
            icon: "fa fa-map-marker",
            dropdown: false,
            children: reportChildren,
            path: "/report",
          };
          mainMenu.splice(13, 0, obj);
        }

        // Report
        if (deliveryChildren.length > 0) {
          let obj = {
            name: "Delivery",
            routeName: "",
            title: "Delivery",
            icon: "fas fa-truck",
            dropdown: false,
            children: deliveryChildren,
            path: "/delivery",
          };
          mainMenu.splice(14, 0, obj);
        }

        // Setting
        if (settingChildren.length > 0) {
          // add new object (PROFILE) to sub menu of SETTING
          let profile = {
            name: "Profile",
            title: "ADMIN_ACCOUNT",
            routeName: "Profile",
            icon: "fas fa-angle-double-right",
            path: ["/setting", "/setting/profile"],
          };

          settingChildren.unshift(profile);

          let obj = {
            name: "Setting",
            routeName: "",
            title: "Setting",
            icon: "fas fa-cog",
            dropdown: false,
            children: settingChildren,
            path: "/setting",
          };
          mainMenu.push(obj);
        }

        // ========= STORE FINAL MENU TO LOCAL STATE AND VUEX ============
        this.menu_list = mainMenu;
        this.$store.dispatch("storePermission", permissions);

        // Use $nextTick to ensure reactivity is updated
        this.$nextTick(() => {
          this.autoExpandActiveDropdown(false);
        });

        if (this.$route?.name === "dashboard") {
          this.$router.push({
            name:
              this.menu_list && this.menu_list.length
                ? this.menu_list[0]?.routeName
                : "notfound",
          });
        }
      }
    },

    dorpDown(item) {
      item.dropdown = !item.dropdown;
    },
  },
};
